import {useNavigate} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import {useContext, useEffect, useState} from "react";
import {Card, CardContent} from "@mui/material";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import MDButton from "../../components/MDButton";
import {CompanyContext} from "../../lib/CompanyProvider";
import {UserContext} from "../../lib/UserProvider";
import {getAssignedWaivers, getClientWaiver, getMyWaivers} from "../common/api/PortalCustomerApi";
import MDTypography from "../../components/MDTypography";
import Loading from "../common/Loading";
import Meta from "../common/Meta";
import {formatDate, getPreferenceValue} from "../common/Utils";

export default function CustomerWaivers(props) {
  const [context, setContext] = useContext(AppContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [userContext, setUserContext] = useContext(UserContext);

  const [company, setCompany] = useState(companyContext?.company);
  const [assignedWaivers, setAssignedWaivers] = useState([]);
  const [myWaivers, setMyWaivers] = useState([]);
  const [assignedWaiversReady, setAssignedWaiversReady] = useState(false);

  const navigate = useNavigate();
  const [pageReady, setPageReady] = useState(false);

  useEffect(() => {
    if (userContext.sessionUser?.userTypeId) {
      let showLogin = !userContext?.sessionUser?.guid?.length > 0;
      setUserContext({...userContext, showLogin: showLogin, loginNag: true});
      setPageReady(!showLogin);
    }
  }, [userContext?.sessionUser]);

  useEffect(() => {
    if (!pageReady) {
      return;
    }
    getMyWaivers().then((resp) => {
      setMyWaivers(resp);
    });
    getAssignedWaivers().then((resp) => {
      setAssignedWaivers(resp);
      setAssignedWaiversReady(true);
    })
  }, [pageReady]);

  useEffect(() => {
    if (companyContext?.company?.guid) {
      setCompany(companyContext.company);
    }
  }, [companyContext?.company]);

  const handleClose = () => {
    // setShowMembershipModal(false);
  }
  const handleSave = (data) => {
    //  setSavingMembership(true);
  }

  const downloadWaiver = async (item) => {
    getClientWaiver(item.guid).then((result) => {
      let blob = new Blob([result], {type: 'application/pdf'});
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, item.waiverName + '.pdf');
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", item.waiverName + '.pdf');
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
  }

  return (
    <>
      <CustomerPageLayout>
        <Meta pageTitle={'Waivers'}/>
        <CustomerHeader props={props}/>

        {pageReady && <MDBox>
          <MDBox m={3} p={1}>
            <h1>
              {companyContext?.company?.preferences && getPreferenceValue(companyContext?.company?.preferences, 'menu_item_waivers', 'Waivers')}
            </h1>

            <Card>
              <CardContent>
                {!assignedWaiversReady && <Loading/>}
                <MDTypography variant={'h5'}>
                  Assigned Waivers
                </MDTypography>
                <div className={'table-responsive'}>
                  <table className="table table-striped">
                    <thead>
                    <tr>
                      <th scope="col">Waiver Name</th>
                      <th scope="col" className="text-right">Version</th>
                      <th scope="col" className="text-right px-5">Complete</th>
                    </tr>
                    </thead>
                    <tbody>
                    {assignedWaivers?.length <= 0 && <>
                      <tr>
                        <td colSpan={3}>
                          <center>No waivers present</center>
                        </td>
                      </tr>
                    </>}
                    {assignedWaivers?.sort((a, b) => b.id - a.id).map((waiver, key) => (
                      <tr key={key}>
                        <td>{waiver.waiverName}</td>
                        <td className="text-right">{waiver.version}</td>
                        <td className="text-right px-5">
                          <MDButton size="small" color="primary"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      navigate('/cx/waiver/' + waiver.guid);
                                    }}>Complete</MDButton>
                          {/*<Link to={'/cx/waiver/' + waiver.guid}>Complete</Link> */}
                        </td>
                      </tr>
                    ))}
                    </tbody>
                  </table>
                </div>

                <Divider/>

                <MDTypography variant={'h5'}>
                  Completed Waivers
                </MDTypography>
                <div className={'table-responsive'}>
                  <table className="table table-striped">
                    <thead>
                    <tr>
                      <th scope="col">Waiver Name</th>
                      <th scope="col" className="text-right">Version</th>
                      <th scope="col">Date</th>
                      <th scope="col" className="text-right px-5">View</th>
                    </tr>
                    </thead>
                    <tbody>
                    {myWaivers?.length <= 0 && <>
                      <tr>
                        <td colSpan={3}>
                          <center>No waivers present</center>
                        </td>
                      </tr>
                    </>}
                    {myWaivers?.sort((a, b) => b.id - a.id).map((waiver, key) => (
                      <tr key={key}>
                        <td>{waiver.waiverName}</td>
                        <td className="text-right">{waiver.version}</td>
                        <td>{waiver.waiverDate ? formatDate(waiver.waiverDate) : ''}</td>
                        <td className="text-right px-5">
                          <MDButton size="small" color="primary"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      downloadWaiver(waiver);
                                    }}>View</MDButton>
                        </td>
                      </tr>
                    ))}
                    </tbody>
                  </table>
                </div>
              </CardContent>
            </Card>
          </MDBox>
        </MDBox>
        }

        <Footer/>
      </CustomerPageLayout>
    </>
  )
}